import { RouteItem } from '@eastcoal/router/types/route'

import { HELP_LINK_PAGE_PATH } from './constants/path'
import { HELP_LINK_ACTION_UUID } from './constants/uuid'

export const helpLinkRoute: RouteItem = {
  title: '帮助文档',
  path: HELP_LINK_PAGE_PATH,
  uuid: HELP_LINK_ACTION_UUID,
  Component: () => import('./index')
}
